var exports = {
  "kL": "FriendSelector.module__container___ckRzV3",
  "hJ": "FriendSelector.module__searchField___ckRzV3",
  "lA": "FriendSelector.module__searchFieldInner___ckRzV3",
  "t$": "FriendSelector.module__selectedPill___ckRzV3",
  "DT": "FriendSelector.module__removeButton___ckRzV3",
  "qc": "FriendSelector.module__searchIcon___ckRzV3",
  "D3": "FriendSelector.module__searchIconFocused___ckRzV3",
  "Rt": "FriendSelector.module__searchInput___ckRzV3",
  "XG": "FriendSelector.module__scroller___ckRzV3",
  "yY": "FriendSelector.module__scrollerNoSearch___ckRzV3",
  "p$": "FriendSelector.module__emptyState___ckRzV3",
  "q6": "FriendSelector.module__emptyStateText___ckRzV3",
  "_s": "FriendSelector.module__groupsContainer___ckRzV3",
  "cp": "FriendSelector.module__groupLetter___ckRzV3",
  "QS": "FriendSelector.module__friendsList___ckRzV3",
  "jZ": "FriendSelector.module__friendButton___ckRzV3",
  "An": "FriendSelector.module__friendButtonSelected___ckRzV3",
  "FI": "FriendSelector.module__friendButtonDisabled___ckRzV3",
  "Hb": "FriendSelector.module__friendInfo___ckRzV3",
  "G3": "FriendSelector.module__friendName___ckRzV3",
  "HI": "FriendSelector.module__checkboxContainer___ckRzV3",
  "Yz": "FriendSelector.module__removeIcon___ckRzV3",
};

module.exports = exports;
